module.exports = "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n\t viewBox=\"0 0 48 48\" style=\"enable-background:new 0 0 48 48;\" xml:space=\"preserve\">\n<g id=\"chevron-right_1_\">\n\t<polygon fill=\"currentColor\" points=\"32.227,24 21.734,13.507 18.062,17.179 24.874,24 18.058,30.816 21.733,34.492\"/>\n</g>\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// ./src/images/chevron-right.svg
// module id = 115
// module chunks = 0